<angular-editor class="w-100 h-50 m-4" [config]="editorConfig" [ngModel]="content" (ngModelChange)="contentChange.emit($event)"></angular-editor>